import styled from '@emotion/styled'
import { useAppDispatch, useAppSelector } from 'src/redux/app/app.hooks'
import { toggleHolidayAnimation, selectIsHolidayAnimationEnabled } from 'src/redux/holidayAnimation'

export const HolidayAnimationToggleButton = () => {
    const isHolidayAnimationEnabled = useAppSelector(selectIsHolidayAnimationEnabled)
    const dispatch = useAppDispatch()

    return (
        <ToggleButton
            onClick={() => dispatch(toggleHolidayAnimation())}
            $active={isHolidayAnimationEnabled}
            role='switch'
            aria-checked={isHolidayAnimationEnabled}
        >
            🌸
        </ToggleButton>
    )
}

const ToggleButton = styled.button<{ $active: boolean }>`
    background: ${props => (props.$active ? '#B39DDB' : 'rgba(128, 128, 128, 0.1)')};
    border: 1px solid ${props => (props.$active ? '#B39DDB' : 'rgba(128, 128, 128, 0.4)')};
    border-radius: 6px;
    cursor: pointer;
    padding: 6px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    transition: all 0.2s ease;
    outline: none;
    color: ${props => (props.$active ? '#ffffff' : 'inherit')};

    &:hover {
        background: ${props => (props.$active ? '#C5B3E6' : 'rgba(128, 128, 128, 0.15)')};
        border-color: ${props => (props.$active ? '#C5B3E6' : 'rgba(128, 128, 128, 0.5)')};
    }

    &:active {
        transform: scale(0.95);
    }
`
